import * as React from 'react';
import type { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgDefectInzetbaar = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width={24}
    height={24}
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M10.84 2.73001C10.95 2.29001 11.35 2.01001 11.8 2.01001H12.2C12.64 2.01001 13.06 2.29001 13.16 2.73001L18.2161 21H20.85C21.13 21 21.35 21.22 21.35 21.5C21.35 21.78 21.13 22 20.85 22H3.15002C2.87002 22 2.65002 21.78 2.65002 21.5C2.65002 21.22 2.87002 21 3.15002 21H5.79348L10.84 2.73001ZM17.17 20.99L16.0699 17.01H7.93017L6.83002 20.99H17.17ZM14.0907 9.85001L15.7935 16.01H8.20659L9.90932 9.85001H14.0907ZM13.8143 8.85001L12.2 3.01001H11.8L10.1857 8.85001H13.8143Z'
    />
  </svg>
);
export default SvgDefectInzetbaar;
